import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

// Carosello orizzontale con swipe nativo. Card larghe ~80% su mobile, ~2.5 su tablet, ~4 su desktop.
export function ProductRail({ title, link, children, itemClassName = "", testid }) {
  return (
    <section className="section-tight" data-testid={testid}>
      <div className="container-page">
        <Reveal className="flex items-end justify-between gap-4">
          <h2 className="display-lg font-extrabold text-foreground">{title}</h2>
          {link && (
            <Link to={link.to} className="flex shrink-0 items-center gap-1.5 text-sm font-semibold text-lime" data-testid={link.testId}>
              {link.label} <ArrowRight className="h-4 w-4" strokeWidth={2} />
            </Link>
          )}
        </Reveal>
      </div>
      <div className="no-scrollbar mt-6 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 sm:px-6 lg:px-[max(1.5rem,calc((100vw-1440px)/2+1.5rem))]">
        {Array.isArray(children) &&
          children.map((child, i) => (
            <div key={i} className={`shrink-0 snap-start ${itemClassName || "w-[78%] sm:w-[46%] md:w-[38%] lg:w-[23%]"}`}>
              {child}
            </div>
          ))}
      </div>
    </section>
  );
}
